<!--邀请有礼设置-->
<template lang="">
<div class="" style="height:100%">
    <div class="handleBox flex flex-jc-sb flex-ai-c">
        <p class="title">推荐有礼规则</p>        
    </div>
    <div class="table" style="height:calc( 100% - 160px );padding-top:20px;position:relative">
        <div style="height:calc(100% - 40px);overflow:auto;">
            <el-form ref="formAuth" :rules="formRules" :model="formData" label-width="93px" label-position="right" size="small" class="alertForm alertForm2">
                <el-form-item label="邀请人数" prop="number" style="margin-bottom:20px">
                    <el-input v-model="formData.number" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="礼品描述" prop="content" style="margin-bottom:20px">
                    <el-input v-model.number="formData.content" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="上传海报" prop="pic" style="width:100%;">
                    <div class="photoBox">
                        <div class="photo flex flex-wrap">
                            <div class="poster" v-if="formData.pic">
                                <el-image :src="getImgUrl(formData.pic)" fit="cover" :preview-src-list="[domain + '/' + formData.pic]"></el-image>
                                <i class="el-icon-error" @click="deleteMain_pic(index)"></i>
                            </div>
                            <label v-if="formData.pic==''">
                                <i class="el-icon-plus"></i>
                                <input type="file" class="uploadMainPic" :value="filevalue" style="display:none" @change="upload('uploadMainPic')" />
                            </label>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div style="position:absolute;bottom:0;left:0;right:0">
            <el-button type="primary" size="small" style="width:100%" @click="onSubmit">提交</el-button>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            filevalue: '',
            formData: {
                pic: '',
                content: '',
                number:''
            },
            formRules: {
                number: [{
                    required: true,
                    message: '请输入邀请人数',
                    trigger: 'blur'
                }],
                pic: [{
                    required: true,
                    message: '请上传海报图片',
                    trigger: 'blur'
                }],
                content: [{
                    required: true,
                    message: '请输入礼品描述',
                    trigger: 'blur'
                }],
            }
        }
    },
    mounted() {
        this.read();
    },
    methods: {
        read: function(){
            this.http.post('/admin/setting/recommendList').then(response => {
                this.formData = response;
            })
        },
        getImgUrl: function(url){
            let urls = this.domain + '/' + url;
            return urls;
        },
        // 附件和图片上传获取接口返回的路径
        upload(uploadelement) {
            var loads = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                customClass: 'myLoading',
            });

            var formData = new FormData();
            formData.append('pic', document.querySelector('.' + uploadelement).files[0]);
            axios.post(this.domain + '/admin/goods/upPic', formData).then(re => {
                loads.close();
                if (re.data.code == '0000') {
                    this.filevalue = "";
                    this.formData.pic = re.data.data.saveName;
                } else {
                    this.$message.error(re.data.msg);
                }
                this.$refs.formAuth.validateField('pic');
            }).catch(function() { // 请求失败处理
                loads.close();
            });
        },
        // 删除主图
        deleteMain_pic() {
            this.formData.pic = '';
            this.$refs.formAuth.validateField('pic');
        },
        onSubmit() {
            this.$refs['formAuth'].validate((valid) => {
                if (valid) {
                    this.http.post('/admin/setting/recommendSave', this.formData).then(() => {
                        this.$message({
                            message: '保存成功!',
                            type: 'success'
                        });
                        this.read();
                    });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>